import React from "react";

function EnterPrisesSidebar({ fill }) {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="BriefcaseOutline">
          <path
            id="Vector"
            d="M17.5 11.0459C15.1171 12.0094 12.5704 12.5032 10 12.5001C7.3475 12.5001 4.81667 11.9834 2.5 11.0459M13.3333 5.00008V3.33341C13.3333 2.89139 13.1577 2.46746 12.8452 2.1549C12.5326 1.84234 12.1087 1.66675 11.6667 1.66675H8.33333C7.89131 1.66675 7.46738 1.84234 7.15482 2.1549C6.84226 2.46746 6.66667 2.89139 6.66667 3.33341V5.00008M10 10.0001H10.0083M4.16667 16.6667H15.8333C16.2754 16.6667 16.6993 16.4912 17.0118 16.1786C17.3244 15.866 17.5 15.4421 17.5 15.0001V6.66675C17.5 6.22472 17.3244 5.8008 17.0118 5.48824C16.6993 5.17568 16.2754 5.00008 15.8333 5.00008H4.16667C3.72464 5.00008 3.30072 5.17568 2.98816 5.48824C2.67559 5.8008 2.5 6.22472 2.5 6.66675V15.0001C2.5 15.4421 2.67559 15.866 2.98816 16.1786C3.30072 16.4912 3.72464 16.6667 4.16667 16.6667Z"
            stroke={fill}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </>
  );
}

export default EnterPrisesSidebar;
